import logo from '../../assets/images/logo.png';
import Container from '../containers/container';

export default function BrandIcon({ size }: { size?: 'sm' | 'lg' }) {
  const pxSize = {
    sm: 27.5,
    lg: 45,
  };
  return (
    <Container extensions="p-3">
      <Container extensions="mobile:hidden tablet-lg:block">
        <img
          height={pxSize[size || 'sm']}
          width={pxSize[size || 'sm']}
          src={logo}
          alt="brand logo"
        />
      </Container>
      <Container extensions="mobile:block tablet-lg:hidden">
        <img height={24} width={24} src={logo} alt="brand logo" />
      </Container>
    </Container>
  );
}
